"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const luxon_1 = require("luxon");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const AmountField_1 = __importStar(require("components/QuickenControls/AmountField"));
const QButton_1 = __importDefault(require("components/QButton"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const RolloverBalanceCalculationView = ({ displayLabel = '', objMonthlyAmounts = {}, budgetItem, hidePopperAndContents, handleRolloverAmountSave, rolloverAmountForDialog, rolloverTableData, editedRolloverAmount, setEditedRolloverAmount, colorBalance, enableBudgetRolloverEdit, }) => {
    const { classes } = useStyles();
    const [showRolloverEdit, setShowRolloverEdit] = (0, react_1.useState)(false);
    const amountFormat = '0,00.00';
    const calculateBalance = ({ budgetAmount, actualAmount }, rolloverAmountPassed, negate) => {
        if (negate > 0) { // Income category
            return rolloverAmountPassed - budgetAmount + actualAmount;
        }
        return rolloverAmountPassed + budgetAmount - actualAmount;
    };
    // eslint-disable-next-line no-unused-vars
    const handleEditResetClick = () => {
        if (showRolloverEdit) {
            setEditedRolloverAmount(rolloverAmountForDialog);
        }
        setShowRolloverEdit(!showRolloverEdit);
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TODO: fix later
    const selectedDate = luxon_1.DateTime.fromISO(objMonthlyAmounts === null || objMonthlyAmounts === void 0 ? void 0 : objMonthlyAmounts.startDate);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TODO: fix later
    const calculatedBalance = calculateBalance(objMonthlyAmounts, editedRolloverAmount, budgetItem === null || budgetItem === void 0 ? void 0 : budgetItem.negate);
    return (<div className={classes.viewRolloverWrapper}>
      <div className={classes.rolloverMainHead}>
        <Typography_1.default variant="subtitle1" color="inherit">
          {displayLabel}
        </Typography_1.default>
        <div>
          <IconButton_1.default className={classes.closeButton} aria-label="Close" id="rollover-dialog-close" onClick={hidePopperAndContents}>
            <Close_1.default />
          </IconButton_1.default>
        </div>
      </div>
      <div className={classes.rolloverDate}>
        <Typography_1.default variant="subtitle2" color="inherit">
          {selectedDate.toFormat('MMMM')} {selectedDate.year}
        </Typography_1.default>
      </div>
      <table className={classes.rolloverTable}>
        {rolloverTableData.map((rolloverTableCell) => (<tr key={rolloverTableCell.key}>
            <td className={classes.rollOverOperation}>{rolloverTableCell.operation}</td>
            <td className={classes.rollOverName}>
              {rolloverTableCell.key}
              <div className={classes.rolloverDatedon}>
                {rolloverTableCell.datedOn}
              </div>
            </td>
            <td className={classes.rollOverAmounts}>
              {showRolloverEdit && rolloverTableCell.key === 'Rollover' &&
                <AmountField_1.default className={classes.input} value={(0, AmountField_1.formatNumber)(editedRolloverAmount, false, amountFormat)} editable hideCurrencyString onChange={(e) => setEditedRolloverAmount(Number(e.target.value) || 0)}/>}
              {(!showRolloverEdit || rolloverTableCell.key !== 'Rollover') && rolloverTableCell.key !== 'Balance' &&
                (0, AmountField_1.formatNumber)(rolloverTableCell.value, false, amountFormat)}
              {rolloverTableCell.key === 'Balance' &&
                <span style={{ color: calculatedBalance < 0 ? colorBalance : undefined }}>
                  {(0, AmountField_1.formatNumber)(calculatedBalance, false, amountFormat)}
                </span>}
            </td>
            <td className={classes.rollOverEdit}>
              {enableBudgetRolloverEdit && rolloverTableCell.edit && (<Button_1.default variant="text" aria-label="edit/reset" onClick={handleEditResetClick} onKeyDown={handleEditResetClick} sx={{ textTransform: 'unset' }}>
                  {showRolloverEdit ? 'Reset' : 'Edit'}
                </Button_1.default>)}
            </td>
          </tr>))}
      </table>
      <div className={classes.buttonWrapper}>
        <QButton_1.default variant="text" onClick={() => budgetItem && handleRolloverAmountSave(budgetItem, objMonthlyAmounts, calculatedBalance)} color="primary" disabled={rolloverAmountForDialog === editedRolloverAmount}>
          SAVE
        </QButton_1.default>
        <QButton_1.default variant="text" color="primary" onClick={hidePopperAndContents}>
          CANCEL
        </QButton_1.default>
      </div>
    </div>);
};
exports.default = RolloverBalanceCalculationView;
